export default __webpack_public_path__ + "static/media/mobile_base_info.ef702c89.svg";